<!-- Экран записи на пробный урок -->
<template>
    <div class="white_container reserve_lesson_container">
        <h2>{{$t("lesson.LBL_CONFIRM_CONTACT_HEADER")}}</h2>
        <p v-html="$t('lesson.LBL_CONTACT_CONFIRM_DESCRIPTION')"></p>
        <div class="form-container">
            <div class="field-wrapper">
                <label>{{$t("profile.LBL_FIRST_NAME")}}</label>
                <div class="input-wrapper">
                    <input type="text" v-model="name"/>
                </div>
            </div>
            <div class="field-wrapper">
                <label>{{$t("profile.LBL_EMAIL")}}</label>
                <div class="input-wrapper">
                    <input type="text" v-model="email"/>
                </div>
            </div>
            <div class="field-wrapper">
                <label>{{$t("profile.LBL_PHONE")}}</label>
                <div class="input-wrapper">
                    <input type="text" v-model="phone"/>
                </div>
            </div>
            <div class="field-wrapper">
                <button :disabled="!validated" class="button" @click="confirm">
                    <span>{{$t("strings.BTN_CONFIRM")}}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '@/store';
    import { mapGetters, mapActions } from 'vuex';
    import {rest} from '@/utils/utils';

    export default {
        name: 'ConfirmContact',
        components: {},
        data: function () {
            return {
                name:"",
                email:"",
                phone:""
            }
        },
        computed: {
            ...mapGetters({
                user: 'user/get',
            }),
            validated(){
                if(!this.name || this.name.toString().trim().length==0) return false;
                if(!this.phone || this.phone.toString().trim().length<5) return false;
                if(!this.email || this.email.toString().trim().length==0 || /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.email)==false) return false;
                return true;
            },
        },
        methods: {
            nextStep() {
                store.commit('trialBookingFlow/currentStep', 'confirmed');
            },
            confirm(){
                if(this.validated){
                    store.commit('loading/is', true);

                    rest.call("confirm_contact",{
                        "data":{
                            "name":this.name,
                            "email":this.email,
                            "phone":this.phone,
                        }
                    },"POST").then((response)=>{
                        store.commit('loading/is',false);
                        if(response.status == "ok"){
                            this.nextStep();
                        }
                    }).catch((error)=>{
                        store.commit('loading/is', false);
                    });
                }
            }
        },
        mounted(){
            store.commit('loading/is', true);
            
            rest.call("get_profile",{},"GET").then((response)=>{
                store.commit('loading/is',false);
                if(response.status == "ok"){
                    this.name = response.data.first_name;
                    this.phone = response.data.phone;
                    this.email = response.data.email;
                }
            }).catch((error)=>{
                store.commit('loading/is', false);
            });
        },
    }
</script>

<style lang="scss" scoped>

</style>
